var $28feffc3d61a8691$exports = {};
$28feffc3d61a8691$exports = {
  "close": "Zav\u0159\xEDt",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " ozn\xE1men\xED");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " ozn\xE1men\xED");
      }
    }), ".");
  }
};
export { $28feffc3d61a8691$exports as default };